import { Card, Typography } from 'antd';
import React from 'react';

import { useGetCompany } from '../../../../firebase/hooks/getCompanyByUid.hook';
import { useAuth } from '../../../Auth/AuthContext';

const { Text } = Typography;

export const ConnectedCompany: React.FC = () => {
  const { currentUser } = useAuth();
  const [company] = useGetCompany(currentUser?.uid);

  if (!company?.nazwa) {
    return null;
  }

  return (
    <Card className="shadow-sm border border-gray-200 rounded-lg" bodyStyle={{ padding: '16px' }}>
      <div className="space-y-2">
        <Text className="text-gray-700 text-sm font-medium">Połączona firma</Text>

        <div className="bg-gray-50 rounded-lg p-2 border border-gray-100">
          <Text strong className="text-gray-900 text-sm break-words">
            {company.nazwa}
          </Text>
        </div>

        {company.nip && (
          <div className="flex items-center space-x-4 text-xs text-gray-600">
            <span>
              NIP:{' '}
              <Text code className="text-xs">
                {company.nip}
              </Text>
            </span>
            {company.numerKRS && (
              <span>
                KRS:{' '}
                <Text code className="text-xs">
                  {company.numerKRS}
                </Text>
              </span>
            )}
          </div>
        )}
      </div>
    </Card>
  );
};
